import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { EmployeeUtil } from '../../utilities/employee.utilities';
import { Account } from '../../models/account';
import { GuardHelperService } from 'src/app/modules/auth/guard-helper.service';

@Injectable()
export class AdminGuard {
  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly guardHelperService: GuardHelperService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.guardHelperService.canActivate(route, state, undefined, this.checkPermissions.bind(this));
  }

  checkPermissions(account: Account): boolean {
    let result = false;
    const employee = this.authService.getCurrentEmployee();

    if (!account.isActive) {
      void this.router.navigateByUrl(`${account.accountUID}/unauthorized`);
    }

    if (EmployeeUtil.IsAdmin(employee)) {
      result = true;
    }

    if (!result) {
      void this.router.navigateByUrl(`${account.accountUID}/settings`);
    }

    return result;
  }
}
